'use strict';

bbw.directive.bbwFileUploadDelegate = function() {
    return {
        link: function(scope, element, attrs) {
            element.on('click', function() {
                var input;
                if (attrs.bbwFileUploadDelegate) {
                    input = document.querySelector(attrs.bbwFileUploadDelegate);
                } else {
                    input = element[0].querySelector('input[type="file"]');
                }
                if (input) {
                    input.click();
                }
            });
        }
    };
};
